import { useQuery } from '@tanstack/react-query';
import { getVerificationEula } from '../requests';
import {
  CACHE_TIME_10_MINUTES,
  CACHE_TIME_5_MINUTES,
  VERIFICATION_EULA_ENABLED,
} from '@/shared/config';

const useVerificationEulaCheckBoxes = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['verification-eula-checkboxes'],
    queryFn: getVerificationEula,
    enabled: VERIFICATION_EULA_ENABLED,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
  });

  return {
    checkBoxes: data?.checkBoxes,
    isEulaCheckBoxesLoading: isLoading,
    isEulaCheckBoxesError: isError,
    eulaCheckBoxesError: error,
  };
};

export { useVerificationEulaCheckBoxes };
